import React, {useEffect, useRef, useState} from 'react';

import Box from "@mui/material/Box";
import CrmLayout from "../../../layout/CRMLayout";
import {
  Avatar,
  Button,
  Checkbox,
  Dialog,
  Drawer,
  FormControl,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Select,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import TreatmentFormButtonCalendar from '../../../components/card-appointment/treatmentCalenderForm';
import Hidden from '@mui/material/Hidden';
import {inputStyle} from "../../../components/form/formInput";
import Autocomplete from "@mui/material/Autocomplete";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Tabs from '@mui/material/Tabs';
import TodayIcon from '@mui/icons-material/Today';
import Tab from '@mui/material/Tab';
import {useNavigate} from "react-router";
import {generateYears, monthsArray} from "../../../services/utills";
import CrmMonthView from "../../../components/crm-calender/CRMMonthView";
import CalenderDrawer from "./calenderDrawer";
import CrmDayView from "../../../components/crm-calender/CRMDayView";
import {useDispatch, useSelector} from "react-redux";
import {getProviderStaff} from "../../../store/crm/staff";
import {useLocation} from "react-router-dom";
import CrmGalleryPanel from "../../../components/modal/CrmGalleryPanel";
import CustomModal from "../../../components/modal/customModal";
import CalenderAppointmentDetail from "./calenderAppointmentDetail";
import CalenderNoteModal from '../../../components/modal/CalenderNotes';
import AddNotesModal from '../../../components/modal/AddNotesModal';
import AddAttachmentModal from '../../../components/modal/AddAttachmentModal';
import AppointmentStaffcalender from '../appointment/AppointmentStaffStatus/appointstaffCalendar';
import AppointmentCalender from '../../../components/card-appointment/AppointmentCalender';
import SetEmailCalenderModal from '../../../components/modal/SetEmailCalenderModal';
import {getAllCalenderBookings, updateCrmCalenderFilter, updateCancelAppointment} from "../../../store/crm/calender";
import {getAppointmentDetails, getAppointmentcalender} from "../../../store/crm/appointment";
import AppointmentDetailscalender from "../appointment/appointment-details/AppoinmnetDetail calender";
import Invoices from "../pos/invoices/Invoices";
import Waveloading from '../../loading/Waveloading';
import toast from 'react-hot-toast';
import CrmPage from '../../../components/mobileview/CrmPage';
import MonthView from '../../../components/mobileview/MonthView';
import moment from 'moment-timezone';
import StaffBreakTimeModal from '../../configuration/clinic-settings/staff/StaffBreakTimeModal';
import DayViewSummary from "./DayViewSummary";
import {getUserDetails} from "../../../store/auth";
import BrandAvatar from "../../../components/avatar/BrandAvatar";
export const arrowStyle = {borderRadius:'unset',background:'#fff',height:'44px',width:"46px",m:"5px"}

export const filterArray =[
    'Day Summary',
    'Day',
    'Month',
]
export const weekday = ["Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday"];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
let timeZone = localStorage.getItem("timeZone");

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    },
  },
};

const legends =[
  {color: '#56CCF2',title:'Unconfirmed Pending'},
  {color: '#323681',title:'Confirmed Pending'},
  {color: '#F2C94C',title:'Checked-In'},
  {color: '#219653',title:'Completed'},
  // {color: '#EB5757',title:'Cancel'},
  {color: '#9A9797',title:'No Show'},
]
const CRMCalender = () => {
  const [startDate, setStartDate] = useState(moment.tz(new Date(), timeZone).toDate());
  const [endDate, setEndDate] =  useState(moment.tz(new Date(), timeZone).toDate());
  const [openDrawer, setOpenDrawer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openAppointmentDetail, setOpenAppointmentDetail] = useState(null);
  const [clientFormDrawerOpen, setClientFormDrawerOpen] = useState(false);
  const [formIframeUrl, setFormIframeUrl] = useState(null);
  const [loadedAppointmentData, setLoadedAppointmentData] = useState(null);
  const [notesDrawerOpen, setNotesDrawerOpen] = useState(false);
  const [notesData, setNotesData] = useState(null);
  const [addNoteDrawerOpen, setAddNoteDrawerOpen] = useState(false);
  const [addPhotoDrawerOpen, setAddPhotoDrawerOpen] = useState(false);
  const [activeSidePanel, setActiveSidePanel] = useState(null);
  const [sideActionLoading, setSideActionLoading] = useState(false);
  const [bookingDetailId, setBookingDetailId] = useState(null);
  const [bookingDetailData, setBookingDetailData] = useState(null);
  const [bookingDetailLoading, setBookingDetailLoading] = useState(false);
  const [invoicePanelBookingId, setInvoicePanelBookingId] = useState(null);
  // Panel the invoice was opened from, so the invoice panel's Back button can
  // restore it after it was closed to make room for the invoice.
  const [invoiceReturnTo, setInvoiceReturnTo] = useState(null);
  const [monthMenuEl, setMonthMenuEl] = useState(null);
  const [yearMenuEl, setYearMenuEl] = useState(null);
  const clientFormRef = useRef(null);
  const staffStripRef = useRef(null);
  // Distinguishes a single click (open day drawer) from a double click (open Day
  // view). The single-click action is deferred briefly so a double click can
  // cancel it before the drawer overlay swallows the second click.
  const dateClickTimerRef = useRef(null);

  const scrollStaffStrip = (dir) => {
    if (staffStripRef.current) {
      staffStripRef.current.scrollBy({ left: dir === "left" ? -260 : 260, behavior: "smooth" });
    }
  };


  const navigate = useNavigate()
  const {pathname} = useLocation()
  const dispatch = useDispatch()

  const crmStaffStore = useSelector(state => state?.crmStaffStore)
  const crmCalenderStore = useSelector(state => state?.crmCalenderStore)
  const crmAppointmentStore = useSelector(state => state?.crmAppointmentStore)
  const {crmStaffs = []} = crmStaffStore
  const {calenderType,calenderBookings=[],selectedStaff,isCancel} = crmCalenderStore
  const {month_counts={},bookings=[]} = calenderBookings
  const {appointmentDetail = {}} = crmAppointmentStore
  const user = useSelector(state => state?.authStore?.user)
  // Only staff accounts are restricted to their own calendar; everyone else keeps
  // the All option. Mirrors the auto-select rule below, which is scoped to role 4.
  const canSeeAllStaff = user?.role_id !== 4 || !!user?.staff_show_all_calendar
 
let count = Array.isArray(bookings)
  ? bookings.length
  : Object.values(bookings).reduce((acc, arr) => acc + (Array.isArray(arr) ? arr.length : 0), 0);
 
// 

//console.log("data comming", calenderBookings)
 
  useEffect(() => {
    (async () => {
      setLoading(true)
      await dispatch(getProviderStaff())
      await fetchCalenderBookings(startDate)
      setLoading(false)
    })()
  }, [])

    // Additional useEffect for handling automatic staff selection based on role_id
    useEffect(() => {
        const autoSelectStaff = async () => {
            if (user?.role_id === 4 && user?.staff_show_all_calendar == 0) {
                // Directly use the logic to update the selectedStaff and fetch bookings
                const selectedStaffId = user.id; // Assuming this is how you get the corresponding staff ID
                await dispatch(updateCrmCalenderFilter({ selectedStaff: selectedStaffId }));
                setLoading(true)
                await fetchCalenderBookings(startDate);
                setLoading(false)

            }
        };

        autoSelectStaff();
    }, [user, dispatch, startDate]);
  const fetchCalenderBookings = async (date)=>{
    setLoading(true)
    await dispatch(getAllCalenderBookings({date:date || startDate}))
    setLoading(false)
  }
  const handleStaffChange = async (event, newValue) => {
    // Tabs onChange gives (event, value); Select onChange gives (event) with event.target.value
    const staffValue = (newValue !== undefined && typeof newValue !== 'object') ? newValue : event?.target?.value;
    setLoading(true);

    try {
        await dispatch(updateCrmCalenderFilter({ selectedStaff: staffValue }));
        await fetchCalenderBookings(startDate);
    } catch (error) {
        console.error('Error during staff change:', error);
    } finally {
        setLoading(false);
    }
};

  const reloadCalendar = async () => {
    // Logic to reload calendar data
      setLoading(true)
      await fetchCalenderBookings(startDate);
      setLoading(false)

  };

  const refreshOpenAppointment = async () => {
      if (!openAppointmentDetail) return;
      const result = await dispatch(getAppointmentcalender(openAppointmentDetail));
      if (result?.payload) setLoadedAppointmentData(result.payload);
  };
 
  const handleDateChange = async (direction) => {
    let newStartDate = new Date(startDate);
    const increment = direction === "left" ? -1 : 1;
  
    if (calenderType === "Month" && newStartDate.getMonth() === 0 && direction === "right") {
      newStartDate = new Date(newStartDate.getFullYear(), 1, 1);
    } else {
    
      switch (calenderType) {
        case "Day":
          newStartDate.setDate(newStartDate.getDate() + increment);
          break;
          case "Day Summary":
          newStartDate.setDate(newStartDate.getDate() + increment);
          break;
        case "Week":
          newStartDate.setDate(newStartDate.getDate() + increment * 7);
          break;
        case "Month":
          newStartDate.setMonth(newStartDate.getMonth() + increment);
        
          const lastDayOfNewMonth = new Date(newStartDate.getFullYear(), newStartDate.getMonth() + 1, 0).getDate();
          if (newStartDate.getDate() > lastDayOfNewMonth) {
            newStartDate.setDate(lastDayOfNewMonth);
          }
          break;
        default:
      
          break;
      }
    }
  
   
    let newEndDate = new Date(newStartDate.getFullYear(), newStartDate.getMonth() + 1, 0);
  
    setStartDate(newStartDate);  
    setEndDate(newEndDate);
      setLoading(true);
      await fetchCalenderBookings(newStartDate);
      setLoading(false);

  };


    const handleAutocomplete = async (event, value) => {
        setLoading(true); // Force loading state immediately

        try {
            // Dispatch the action to update the calendar type
            await dispatch(updateCrmCalenderFilter({ calenderType: value }));

            // Update date range based on the new view
            let newEndDate = startDate;
            if (value === 'Week') {
                newEndDate = new Date(startDate);
                newEndDate.setDate(newEndDate.getDate() + 6);
            } else if (value === 'Month') {
                newEndDate = new Date(startDate);
                newEndDate.setMonth(newEndDate.getMonth() + 1);
            }
            setEndDate(newEndDate);

            // Fetch bookings after state is updated
            await fetchCalenderBookings(startDate);
        } catch (error) {
            console.error("Error changing calendar view:", error);
        } finally {
            setLoading(false); // Always stop loading
        }
    };


  const formatDate = () => {
    if(calenderType === 'Month') {
      return startDate.toLocaleDateString("en-US", {month: "short", year: "numeric"});
    }
    else if (calenderType === 'Week') {
      return startDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
      }) + " - " + endDate.toLocaleDateString("en-US", {month: "short", day: "numeric"});
    } else if (calenderType === 'Day') {
      return weekday[startDate?.getDay()] + " - " + startDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
      });
    }else if (calenderType === 'Day Summary') {
      return weekday[startDate?.getDay()] + " - " + startDate.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric"
      });
    }
  }
  
  const handleRedirect = (url) => {
    navigate(url)
  }
 
  const handleDateClick = (date, appointments = []) => {
    // Single-click a day cell → open that day's appointment sidebar (drawer).
    // (Appointment dots call stopPropagation and open the detail panel instead;
    //  double-clicking the cell drills into the full Day view.)
    // Defer briefly so a double click can cancel this before the drawer opens.
    if (dateClickTimerRef.current) clearTimeout(dateClickTimerRef.current);
    dateClickTimerRef.current = setTimeout(() => {
      dateClickTimerRef.current = null;
      setOpenDrawer(appointments || []);
    }, 250);
  }

  // Double-clicking any month cell jumps straight into that day's Day view
  // (single click opens the day's sidebar drawer instead).
  const handleDateDoubleClick = async (date) => {
    // Cancel the pending single-click (drawer) action.
    if (dateClickTimerRef.current) {
      clearTimeout(dateClickTimerRef.current);
      dateClickTimerRef.current = null;
    }
    setOpenDrawer(null);
    const newStartDate = new Date(date);
    setStartDate(newStartDate);
    await dispatch(updateCrmCalenderFilter({ calenderType: "Day" }));
    setLoading(true);
    await fetchCalenderBookings(date);
    setLoading(false);
  }
    useEffect(() => {
        const autoCheckCancel = async () => {
            // If user has a setting that should show cancelled bookings by default
            // Modify this condition as needed
            if (user?.auto_show_cancel_bookings === 1 && !isCancel) {
                await handleCheckCancel();
            }
        };

        if (user) {
            autoCheckCancel();
        }
    }, [user]);

    useEffect(() => {
        if (!bookingDetailId) {
            setBookingDetailData(null);
            return;
        }
        (async () => {
            setBookingDetailLoading(true);
            try {
                const { payload } = await dispatch(getAppointmentDetails(bookingDetailId));
                if (payload && !Array.isArray(payload)) {
                    setBookingDetailData(payload);
                } else {
                    setBookingDetailData(null);
                }
            } finally {
                setBookingDetailLoading(false);
            }
        })();
    }, [bookingDetailId]);

    const handleCheckCancel = async () => {
        const updatedValue = !isCancel;
        setLoading(true);
        await dispatch(updateCancelAppointment(updatedValue));
        await   dispatch ( getUserDetails())
        await dispatch(updateCrmCalenderFilter({ isCancel: updatedValue }));
        await fetchCalenderBookings(startDate);
        setLoading(false);
    };

    // Clickable month label → pick a month. Preserves the current view
    // (Month stays Month, Day stays Day) so it works from both headers.
    const handleSelectMonth = async (key) => {
        setMonthMenuEl(null);
        const end = new Date(startDate);
        end.setMonth(key);
        setStartDate(end);
        setLoading(true);
        await fetchCalenderBookings(end);
        setLoading(false);
    };

    // Clickable year label → pick a year
    const handleSelectYear = async (yr) => {
        setYearMenuEl(null);
        const newDate = new Date(startDate);
        newDate.setFullYear(Number(yr));
        setStartDate(newDate);
        setLoading(true);
        await fetchCalenderBookings(newDate);
        setLoading(false);
    };
  return (
      <CrmLayout>
        {/* Suppress the full-page loader while the appointment detail dialog is open —
            that panel shows its own loader, so this avoids two overlapping spinners. */}
        {loading && openAppointmentDetail === null ? <Waveloading fullSize/> : ""}
        {/* ── UNIFIED TOOLBAR (one row, responsive) ── */}
        <Box sx={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          background: '#FAEFF5',
          borderRadius: '14px',
          px: { xs: 1.25, sm: 2 }, py: 1,
          mb: 2, mt: 2,
          border: '1px solid #F0CDDB',
          flexWrap: 'wrap', rowGap: 1, columnGap: { xs: 1, sm: 1.5 },
        }}>

          {/* Left – date (clickable month/year in Month view) + nav + Today */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexWrap: 'wrap', minWidth: 0 }}>
            {calenderType === 'Month' ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                <Box
                  onClick={(e) => setMonthMenuEl(e.currentTarget)}
                  sx={{
                    display: 'flex', alignItems: 'center', cursor: 'pointer',
                    px: 0.75, py: 0.25, borderRadius: '8px',
                    '&:hover': { background: '#F0CDDB' },
                  }}
                >
                  <Typography sx={{ fontWeight: 800, fontSize: { xs: '15px', sm: '17px' }, color: '#1a1a2e' }}>
                    {monthsArray[startDate.getMonth()]?.name}
                  </Typography>
                  <KeyboardArrowDownIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                </Box>
                <Box
                  onClick={(e) => setYearMenuEl(e.currentTarget)}
                  sx={{
                    display: 'flex', alignItems: 'center', cursor: 'pointer',
                    px: 0.75, py: 0.25, borderRadius: '8px',
                    '&:hover': { background: '#F0CDDB' },
                  }}
                >
                  <Typography sx={{ fontWeight: 800, fontSize: { xs: '15px', sm: '17px' }, color: '#A72C68' }}>
                    {startDate.getFullYear()}
                  </Typography>
                  <KeyboardArrowDownIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                </Box>
              </Box>
            ) : (calenderType === 'Day' || calenderType === 'Day Summary') ? (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25, flexWrap: 'wrap' }}>
                <Typography sx={{ fontWeight: 800, fontSize: { xs: '14px', sm: '16px' }, color: '#1a1a2e', whiteSpace: 'nowrap', mr: 0.25 }}>
                  {weekday[startDate.getDay()]} -
                </Typography>
                <Box
                  onClick={(e) => setMonthMenuEl(e.currentTarget)}
                  sx={{
                    display: 'flex', alignItems: 'center', cursor: 'pointer',
                    px: 0.5, py: 0.25, borderRadius: '8px',
                    '&:hover': { background: '#F0CDDB' },
                  }}
                >
                  <Typography sx={{ fontWeight: 800, fontSize: { xs: '14px', sm: '16px' }, color: '#1a1a2e', whiteSpace: 'nowrap' }}>
                    {monthsArray[startDate.getMonth()]?.name} {startDate.getDate()}
                  </Typography>
                  <KeyboardArrowDownIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                </Box>
                <Box
                  onClick={(e) => setYearMenuEl(e.currentTarget)}
                  sx={{
                    display: 'flex', alignItems: 'center', cursor: 'pointer',
                    px: 0.5, py: 0.25, borderRadius: '8px',
                    '&:hover': { background: '#F0CDDB' },
                  }}
                >
                  <Typography sx={{ fontWeight: 800, fontSize: { xs: '14px', sm: '16px' }, color: '#A72C68' }}>
                    {startDate.getFullYear()}
                  </Typography>
                  <KeyboardArrowDownIcon sx={{ fontSize: 18, color: '#A72C68' }} />
                </Box>
              </Box>
            ) : (
              <Typography sx={{ fontWeight: 800, fontSize: { xs: '14px', sm: '16px' }, color: '#1a1a2e', whiteSpace: 'nowrap', px: 0.5 }}>
                {formatDate()}
              </Typography>
            )}

            <IconButton size="small" onClick={() => handleDateChange("left")} sx={{ color: '#555', '&:hover': { color: '#A72C68', background: '#fff' } }}>
              <KeyboardArrowLeftIcon />
            </IconButton>
            <IconButton size="small" onClick={() => handleDateChange("right")} sx={{ color: '#555', '&:hover': { color: '#A72C68', background: '#fff' } }}>
              <KeyboardArrowRightIcon />
            </IconButton>
            <Button
              variant="outlined"
              onClick={async () => {
                const today = moment.tz(new Date(), timeZone).toDate();
                setStartDate(today);
                setLoading(true);
                await fetchCalenderBookings(today);
                setLoading(false);
              }}
              sx={{
                border: '1.5px solid #d0d5dd', color: '#333', borderRadius: '9px',
                px: 1.5, textTransform: 'none', fontWeight: 700, height: '34px', minWidth: 0,
                fontSize: '13px', flexShrink: 0,
                '&:hover': { borderColor: '#A72C68', color: '#A72C68', background: '#fff' },
              }}
            >
              Today
            </Button>
          </Box>

          {/* Right – total + staff + view switch + break + add */}
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap',
            justifyContent: { xs: 'flex-start', sm: 'flex-end' },
          }}>
            {/* Total appointments */}
            <Box sx={{
              display: 'flex', alignItems: 'center', gap: 0.75,
              background: '#fff', borderRadius: '9px', px: 1.25, py: '5px', height: '34px',
            }}>
              <TodayIcon sx={{ color: '#A72C68', fontSize: 18 }} />
              <Typography sx={{ fontWeight: 800, fontSize: '16px', color: '#1a1a2e', lineHeight: 1 }}>{count}</Typography>
              <Typography sx={{ fontSize: '12px', fontWeight: 600, color: '#777', whiteSpace: 'nowrap' }}>total</Typography>
            </Box>

            {/* Staff dropdown (Day view only) */}
            {calenderType === 'Day' && (
              <Select
                value={selectedStaff || 'all'}
                onChange={handleStaffChange}
                displayEmpty
                size="small"
                MenuProps={MenuProps}
                sx={{
                  height: '34px', fontSize: '13px', fontWeight: 700,
                  background: '#fff', borderRadius: '9px',
                  minWidth: '120px', maxWidth: '170px', color: '#1a1a2e',
                  '.MuiOutlinedInput-notchedOutline': { border: 'none' },
                  '&:hover .MuiOutlinedInput-notchedOutline': { border: 'none' },
                  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { border: 'none' },
                  '.MuiSelect-icon': { color: '#A72C68' },
                }}
              >
                {canSeeAllStaff && (
                  <MenuItem value="all" sx={{ fontSize: '13px', fontWeight: 600 }}>All staff</MenuItem>
                )}
                {crmStaffs?.map((s) => (
                  <MenuItem key={s.id} value={s.id} sx={{ fontSize: '13px' }}>{s.name}</MenuItem>
                ))}
              </Select>
            )}

            {/* View switcher (Day Summary / Day / Month) */}
            <Box sx={{ display: 'flex', background: '#fff', borderRadius: '9px', p: '3px', gap: '3px' }}>
              {filterArray.map((type) => {
                const selected = calenderType === type;
                return (
                  <Button
                    key={type}
                    onClick={() => handleAutocomplete(null, type)}
                    sx={{
                      px: 1.25, minWidth: 0, height: '28px', borderRadius: '7px',
                      textTransform: 'none', fontSize: '13px', fontWeight: 600,
                      background: selected ? '#A72C68' : 'transparent',
                      color: selected ? '#fff' : '#1a1a2e',
                      boxShadow: 'none', whiteSpace: 'nowrap',
                      '&:hover': {
                        background: selected ? '#921F58' : 'rgba(167,44,104,0.08)',
                        color: selected ? '#fff' : '#A72C68',
                      },
                    }}
                  >
                    {type}
                  </Button>
                );
              })}
            </Box>

            {/* Block Hours (break time) — kept next to Add Appointment */}
            <Box sx={{ height: '34px', display: 'flex', alignItems: 'center' }}>
              <StaffBreakTimeModal marginBlock={"0"} onRescheduleSuccess={reloadCalendar} />
            </Box>

            {/* Add appointment */}
            <Button
              sx={{
                background: '#27AE60',
                color: '#fff', borderRadius: '9px',
                textTransform: 'none', fontWeight: 700,
                px: { xs: 1.5, sm: 2 }, height: '34px',
                fontSize: '13px', whiteSpace: 'nowrap',
                boxShadow: 'none',
                '&:hover': { background: '#219653', boxShadow: 'none' },
              }}
              onClick={() => { localStorage.setItem('url', pathname); handleRedirect("/crm/add-appointment"); }}
            >
              Add Appointment
            </Button>
          </Box>
        </Box>

        {/* Clickable Month picker */}
        <Menu
          anchorEl={monthMenuEl}
          open={Boolean(monthMenuEl)}
          onClose={() => setMonthMenuEl(null)}
          PaperProps={{ sx: { maxHeight: 320, mt: 0.5, borderRadius: '10px' } }}
        >
          {monthsArray.map((item) => (
            <MenuItem
              key={item.key}
              selected={startDate.getMonth() === item.key}
              onClick={() => handleSelectMonth(item.key)}
              sx={{ fontSize: '13px', fontWeight: startDate.getMonth() === item.key ? 700 : 500 }}
            >
              {item.name} ({month_counts[item.index] || 0})
            </MenuItem>
          ))}
        </Menu>

        {/* Clickable Year picker */}
        <Menu
          anchorEl={yearMenuEl}
          open={Boolean(yearMenuEl)}
          onClose={() => setYearMenuEl(null)}
          PaperProps={{ sx: { maxHeight: 320, mt: 0.5, borderRadius: '10px' } }}
        >
          {generateYears(20)?.map((yr) => (
            <MenuItem
              key={yr}
              selected={startDate.getFullYear() === yr}
              onClick={() => handleSelectYear(yr)}
              sx={{ fontSize: '13px', fontWeight: startDate.getFullYear() === yr ? 700 : 500 }}
            >
              {yr}
            </MenuItem>
          ))}
        </Menu>

        {/* ── Staff strip (Month view) — horizontal, scrollable, burgundy scheme ── */}
        {calenderType === 'Month' && crmStaffs?.length > 0 && (
          <Box sx={{
            display: 'flex', alignItems: 'center', gap: 1.5,
            background: '#fff', border: '1px solid #F0CDDB', borderRadius: '14px',
            px: { xs: 1.5, sm: 2.5 }, py: 1, mb: 2,
          }}>
            <Typography sx={{ fontWeight: 800, fontSize: { xs: '14px', sm: '16px' }, color: '#1a1a2e', flexShrink: 0 }}>
              Staff:
            </Typography>

            {/* All */}
            {canSeeAllStaff && (
            <Box
              onClick={() => handleStaffChange(null, 'all')}
              sx={{
                flexShrink: 0, cursor: 'pointer', px: 1, pb: 0.75, pt: 0.5,
                borderBottom: `3px solid ${(!selectedStaff || selectedStaff === 'all') ? '#A72C68' : 'transparent'}`,
              }}
            >
              <Typography sx={{
                fontWeight: 800, fontSize: { xs: '14px', sm: '15px' }, whiteSpace: 'nowrap',
                color: (!selectedStaff || selectedStaff === 'all') ? '#A72C68' : '#1a1a2e',
              }}>
                All
              </Typography>
            </Box>
            )}

            {/* Scrollable staff list */}
            <Box
              ref={staffStripRef}
              sx={{
                display: 'flex', alignItems: 'center', gap: { xs: 1.5, sm: 2.5 },
                overflowX: 'auto', flex: 1, minWidth: 0,
                '&::-webkit-scrollbar': { display: 'none' },
                scrollbarWidth: 'none',
              }}
            >
              {crmStaffs.map((s) => {
                const active = selectedStaff === s.id;
                return (
                  <Box
                    key={s.id}
                    onClick={() => handleStaffChange(null, s.id)}
                    sx={{
                      display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer',
                      flexShrink: 0, pb: 0.75, pt: 0.5,
                      borderBottom: `3px solid ${active ? '#A72C68' : 'transparent'}`,
                      transition: 'border-color 0.15s',
                      '&:hover': { borderColor: active ? '#A72C68' : '#F0CDDB' },
                    }}
                  >
                    <Avatar
                      src={s.profile_image}
                      variant="rounded"
                      sx={{ width: 38, height: 38, borderRadius: '10px', flexShrink: 0 }}
                    >
                      {s.name?.charAt(0)?.toUpperCase()}
                    </Avatar>
                    <Typography sx={{
                      fontWeight: active ? 800 : 600, fontSize: { xs: '13px', sm: '14px' },
                      whiteSpace: 'nowrap', color: active ? '#A72C68' : '#1a1a2e',
                    }}>
                      {s.name}
                    </Typography>
                  </Box>
                );
              })}
            </Box>

            {/* Scroll arrow */}
            <IconButton
              size="small"
              onClick={() => scrollStaffStrip('right')}
              sx={{
                flexShrink: 0, background: '#FAEFF5', border: '1px solid #F0CDDB',
                borderRadius: '8px', color: '#A72C68', width: 32, height: 32,
                '&:hover': { background: '#F0CDDB' },
              }}
            >
              <KeyboardArrowRightIcon sx={{ fontSize: 20 }} />
            </IconButton>
          </Box>
        )}

        {/* View area + legend fill the page so the legend pins to the bottom */}
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: { xs: 'auto', sm: 'calc(100vh - 230px)' } }}>
        {calenderType === 'Month' &&
            <Box sx={{ width: '100%', minWidth: 0 }}>
              <CrmMonthView
                  monthViewData={bookings}
                  startDate={startDate}
                  onAppointmentClick={setOpenAppointmentDetail}
                  handleDateClick={handleDateClick}
                  handleDateDoubleClick={handleDateDoubleClick}
              />
            </Box>
        }
        {calenderType === 'Day' &&
            <Box sx={{ width: '100%', minWidth: 0 }}>
              <CrmDayView
                onRescheduleSuccess={reloadCalendar}
                  dayViewData={bookings}
                  setOpenAppointmentDetail={setOpenAppointmentDetail}
                  startDate={startDate}
                  minStartTime={calenderBookings?.min_start_time}
                  maxEndTime={calenderBookings?.max_end_time}
                  blockHours={calenderBookings?.block_hours}
                  crmStaffs={crmStaffs}
                  selectedStaff={selectedStaff}
              />
            </Box>
        }
          {calenderType === 'Day Summary' &&
              <Box sx={{ width: '100%', minWidth: 0 }}>
                  <DayViewSummary
                      date={startDate}
                      setOpenAppointmentDetail={setOpenAppointmentDetail}
                      appointments={bookings}
                  />
              </Box>
          }

        {/* ── LEGENDS (pinned to bottom of page, compact) ── */}
        <Box sx={{
          background: '#FAEFF5',
          borderRadius: '10px',
          p: { xs: 1, sm: '10px 16px' },
          mt: 2,
          display: 'flex', alignItems: 'center', flexWrap: 'wrap',
          rowGap: 0.75, columnGap: { xs: 1.25, sm: 2 },
        }}>
          <Typography sx={{ fontSize: '12px', fontWeight: 700, color: '#555', mr: 0.5 }}>
            Legends:
          </Typography>
          {legends.map((item, index) => (
            <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
              <Box sx={{ width: '11px', height: '11px', background: item?.color, borderRadius: '3px' }} />
              <Typography sx={{ fontSize: '12px', color: '#444' }}>{item?.title}</Typography>
            </Box>
          ))}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer' }} onClick={handleCheckCancel}>
            <Box sx={{ width: '11px', height: '11px', background: '#EB5757', borderRadius: '3px' }} />
            <Typography sx={{ fontSize: '12px', color: '#444' }}>Cancel/Void</Typography>
            <Checkbox onChange={handleCheckCancel} checked={Boolean(isCancel)} size="small" sx={{ p: '2px' }} />
          </Box>
        </Box>
        </Box>

        <CalenderDrawer
            setOpenAppointmentDetail={setOpenAppointmentDetail}
            appointmentLists={openDrawer}
            setOpen={()=>{
              setOpenDrawer(null)
            }}
        />
        {/* ── Modal 1 + 2 + 3: right-side, Modal 1 fixed width, 2 & 3 slide in to its left ── */}
        <Dialog
            keepMounted
            open={openAppointmentDetail !== null && formIframeUrl === null && !addNoteDrawerOpen && !addPhotoDrawerOpen}
            onClose={() => { setOpenAppointmentDetail(null); setClientFormDrawerOpen(false); setNotesDrawerOpen(false); setNotesData(null); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setActiveSidePanel(null); setBookingDetailId(null); setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }}
            maxWidth={false}
            sx={{
                '& .MuiDialog-container': {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    padding: { xs: 0, md: '12px 12px 12px 0' },
                    // Bound the whole dialog to the *visible* viewport on phones.
                    // .MuiDialog-root is position:fixed; inset:0, and Chrome Android
                    // sizes fixed elements against the layout viewport — the large
                    // viewport, i.e. including the strip behind the URL bar. So both
                    // 100vh and a plain height:100% leave the bottom of the dialog
                    // off-screen, taking the panel footer (Confirm Reschedule) with
                    // it. 100dvh tracks the area actually on screen.
                    height: { xs: '100dvh', md: '100%' },
                    maxHeight: { xs: '100dvh', md: '100%' },
                },
            }}
            PaperProps={{
                sx: {
                    // 100% of the container, which is capped at 100dvh above.
                    height: { xs: '100%', md: 'calc(100vh - 24px)' },
                    maxHeight: { xs: '100%', md: 'calc(100vh - 24px)' },
                    width: { xs: '100vw', sm: '100vw', md: 'auto' },
                    maxWidth: { xs: '100vw', sm: '100vw', md: '100%' },
                    borderRadius: { xs: 0, md: '16px' },
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'row',
                    m: 0,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                }
            }}
        >
            {/* Side Panel — staff / reschedule / email — slides in left of Panel 1 */}
            <Box sx={{
                width: activeSidePanel
                    ? activeSidePanel?.type === 'reschedule'
                        ? { xs: '100vw', sm: '92vw', md: '640px', lg: '720px' }
                        : { xs: '100vw', sm: '90vw', md: '500px', lg: '508px' }
                    : 0,
                flexShrink: 1,
                minWidth: 0,
                // Bound the panel to the Paper's height so a long time-slot list
                // can't stretch it and push its own footer out of view.
                height: '100%',
                minHeight: 0,
                overflow: 'hidden',
                position: 'relative',
                borderRight: activeSidePanel ? '1px solid #eef0f4' : 'none',
                transition: 'width 0.28s ease',
                display: 'flex',
                flexDirection: 'column',
            }}>
                {sideActionLoading && activeSidePanel && <Waveloading cover />}
                {activeSidePanel?.type === 'email' && loadedAppointmentData && (
                    <SetEmailCalenderModal
                        customer_id={loadedAppointmentData?.customer?.id}
                        panelMode
                        onPanelClose={() => setActiveSidePanel(null)}
                        onActionStart={() => { setSideActionLoading(true); }}
                        onActionEnd={async (msg) => { await Promise.all([refreshOpenAppointment(), reloadCalendar()]); setSideActionLoading(false); setActiveSidePanel(null); if (msg) toast.success(msg); }}
                    />
                )}
                {activeSidePanel?.type === 'reschedule' && loadedAppointmentData && (
                    <AppointmentCalender
                        appointment={loadedAppointmentData}
                        panelMode
                        isCalender
                        onPanelClose={() => setActiveSidePanel(null)}
                        onActionStart={() => { setSideActionLoading(true); }}
                        onActionEnd={async (msg) => { await Promise.all([refreshOpenAppointment(), reloadCalendar()]); setSideActionLoading(false); setActiveSidePanel(null); if (msg) toast.success(msg); }}
                    />
                )}
                {activeSidePanel?.type === 'staff' && loadedAppointmentData && (
                    <AppointmentStaffcalender
                        appointment={loadedAppointmentData}
                        {...(activeSidePanel.config || {})}
                        panelMode
                        onPanelClose={() => setActiveSidePanel(null)}
                        onActionStart={() => { setSideActionLoading(true); }}
                        onActionEnd={async (msg) => { await Promise.all([refreshOpenAppointment(), reloadCalendar()]); setSideActionLoading(false); setActiveSidePanel(null); if (msg) toast.success(msg); }}
                    />
                )}
                {activeSidePanel?.type === 'photos' && loadedAppointmentData?.customer?.id && (
                    <CrmGalleryPanel
                        user_id={loadedAppointmentData.customer.id}
                        onClose={() => setActiveSidePanel(null)}
                    />
                )}
            </Box>

            {/* Panel 3: Patient Records (Notes) — slides in left of Panel 2 */}
            <Box sx={{
                width: notesDrawerOpen ? { xs: '100vw', sm: '90vw', md: '500px', lg: '605px' } : 0,
                flexShrink: 1,
                minWidth: 0,
                overflow: 'hidden',
                borderRight: notesDrawerOpen ? '1px solid #eef0f4' : 'none',
                transition: 'width 0.28s ease',
                display: 'flex',
                flexDirection: 'column',
                position: 'relative',
            }}>
                {notesData && (
                    <CalenderNoteModal
                        panelMode
                        onPanelClose={() => setNotesDrawerOpen(false)}
                        customer_id={notesData?.customer?.id}
                        appointment_id={notesData?.id}
                        name={notesData?.customer?.name}
                        data={notesData}
                        onAddNoteOpen={() => { setNotesDrawerOpen(false); setClientFormDrawerOpen(false); setAddPhotoDrawerOpen(false); setAddNoteDrawerOpen(true); }}
                        onAddPhotoOpen={() => { setNotesDrawerOpen(false); setClientFormDrawerOpen(false); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(true); }}
                        onBookingClick={(bookingId) => { if (bookingId) setBookingDetailId(bookingId); }}
                    />
                )}
                {/* Overlay: Booking Detail panel — shown on top of Patient Records when a booking number is clicked */}
                {bookingDetailId && (
                    <Box sx={{
                        position: 'absolute',
                        inset: 0,
                        background: '#fff',
                        zIndex: 5,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}>
                        {/* Header — matches Appointment Detail panel style */}
                        <Box sx={{
                            px: 2.5, py: 1.5, borderBottom: '1px solid #f3f4f6',
                            background: '#fff', display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0,
                        }}>
                            <Tooltip title="Back" placement="bottom">
                                <IconButton size="small" onClick={() => setBookingDetailId(null)} sx={{ color: '#9ca3af', borderRadius: '8px', '&:hover': { color: '#6366f1', background: '#eef2ff' } }}>
                                    <ArrowBackIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                            </Tooltip>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                                <Typography sx={{ fontSize: '13px', fontWeight: 700, color: '#111827' }}>
                                    Reservation ID #{bookingDetailId}
                                </Typography>
                            </Box>
                            <Tooltip title="Close" placement="bottom">
                                <IconButton size="small" onClick={() => setBookingDetailId(null)} sx={{ color: '#9ca3af', borderRadius: '8px', '&:hover': { color: '#ef4444', background: '#fef2f2' } }}>
                                    <CloseIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                            </Tooltip>
                        </Box>

                        {/* Scrollable Body — same background + scrollbar style as Appointment Detail panel */}
                        <Box sx={{
                            flex: 1, overflowY: 'auto', background: '#f9fafb', position: 'relative',
                            '&::-webkit-scrollbar': { width: '4px' },
                            '&::-webkit-scrollbar-thumb': { borderRadius: '4px', background: 'rgba(0,0,0,0.1)' },
                        }}>
                            {bookingDetailLoading && <Waveloading cover />}
                            {bookingDetailData ? (
                                <Box sx={{ p: 2 }}>
                                    <AppointmentDetailscalender
                                        appointmentDetails={bookingDetailData}
                                        onInvoiceClick={(id) => {
                                            if (!id) return;
                                            // Remember what to come back to, then close Patient Records +
                                            // the Booking Detail overlay so the invoice panel gets the space.
                                            setInvoiceReturnTo({ bookingDetailId, notesOpen: notesDrawerOpen });
                                            setBookingDetailId(null);
                                            setNotesDrawerOpen(false);
                                            setClientFormDrawerOpen(false);
                                            setActiveSidePanel(null);
                                            setInvoicePanelBookingId(id);
                                        }}
                                    />
                                </Box>
                            ) : !bookingDetailLoading ? (
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
                                    <Typography sx={{ color: '#9A9797', fontSize: '14px' }}>
                                        No appointment data found for booking {bookingDetailId}.
                                    </Typography>
                                </Box>
                            ) : null}
                        </Box>
                    </Box>
                )}
            </Box>

            {/* Panel 2: Client Forms — slides in left of Panel 1 */}
            <Box sx={{
                width: clientFormDrawerOpen ? { xs: '100vw', sm: '90vw', md: '640px', lg: '860px', xl: '940px' } : 0,
                flexShrink: 1,
                minWidth: 0,
                overflow: 'hidden',
                borderRight: clientFormDrawerOpen ? '1px solid #eef0f4' : 'none',
                transition: 'width 0.28s ease',
                display: 'flex',
                flexDirection: 'column',
            }}>
                <TreatmentFormButtonCalendar
                    ref={clientFormRef}
                    data={loadedAppointmentData || {}}
                    panelMode
                    onPanelOpen={() => { setClientFormDrawerOpen(true); setActiveSidePanel(null); setNotesDrawerOpen(false); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setBookingDetailId(null); setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }}
                    onPanelClose={() => setClientFormDrawerOpen(false)}
                    onFormSelect={(url) => setFormIframeUrl(url)}
                />
            </Box>

            {/* Invoice Panel — slides in to the left of Panel 1, parallel to Appointment Detail */}
            <Box sx={{
                width: invoicePanelBookingId ? { xs: '100vw', sm: '90vw', md: '700px', lg: '780px' } : 0,
                flexShrink: 1,
                minWidth: 0,
                overflow: 'hidden',
                borderRight: invoicePanelBookingId ? '1px solid #eef0f4' : 'none',
                transition: 'width 0.28s ease',
                display: 'flex',
                flexDirection: 'column',
                background: '#fff',
            }}>
                {invoicePanelBookingId && (
                    <>
                        <Box sx={{
                            display: 'flex', alignItems: 'center', px: 2.5, py: 1.5,
                            borderBottom: '1px solid #f3f4f6', flexShrink: 0, background: '#fff', gap: 1,
                        }}>
                            <Tooltip title="Back" placement="bottom">
                                <IconButton size="small" onClick={() => { setInvoicePanelBookingId(null); if (invoiceReturnTo) { setNotesDrawerOpen(Boolean(invoiceReturnTo.notesOpen)); setBookingDetailId(invoiceReturnTo.bookingDetailId || null); setInvoiceReturnTo(null); } }} sx={{ color: '#9ca3af', borderRadius: '8px', '&:hover': { color: '#A72C68', background: '#FAEFF5' } }}>
                                    <ArrowBackIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                            </Tooltip>
                            <Typography sx={{ flex: 1, fontWeight: 700, fontSize: '15px', color: '#111827', fontFamily: 'helvetica-lt-std-bold,sans-serif' }}>
                                Invoice #{invoicePanelBookingId}
                            </Typography>
                            <Tooltip title="Close" placement="bottom">
                                <IconButton size="small" onClick={() => { setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }} sx={{ color: '#9ca3af', borderRadius: '8px', '&:hover': { color: '#ef4444', background: '#fef2f2' } }}>
                                    <CloseIcon sx={{ fontSize: 17 }} />
                                </IconButton>
                            </Tooltip>
                        </Box>
                        <Box sx={{
                            flex: 1, overflowY: 'auto', background: '#f9fafb',
                            '&::-webkit-scrollbar': { width: '8px' },
                            '&::-webkit-scrollbar-track': { background: '#FAEFF5', borderRadius: '8px' },
                            '&::-webkit-scrollbar-thumb': { background: '#A72C68', borderRadius: '8px', border: '2px solid #FAEFF5' },
                            '&::-webkit-scrollbar-thumb:hover': { background: '#921F58' },
                        }}>
                            <Invoices booking_id={invoicePanelBookingId} panelMode />
                        </Box>
                    </>
                )}
            </Box>

            {/* Panel 1: Appointment Detail — keeps its width unless the pair of open
                panels would not fit, in which case both give up space evenly. */}
            <Box sx={{
                width: {xs: '100vw', sm: '100vw', md: '700px', lg: '748px'},
                flexShrink: 1,
                minWidth: 0,
                overflow: 'hidden',
                position: 'relative',
                display: {
                    xs: (notesDrawerOpen || clientFormDrawerOpen || activeSidePanel || invoicePanelBookingId) ? 'none' : 'flex',
                    md: 'flex',
                },
                // With the reschedule panel open, keep this panel visible from
                // 768px up — both shrink proportionally to fit the viewport
                // rather than this one being pushed off-screen.
                ...(activeSidePanel?.type === 'reschedule'
                    ? { '@media (min-width:768px)': { display: 'flex' } }
                    : {}),
                flexDirection: 'column',
            }}>
                {sideActionLoading && !activeSidePanel && <Waveloading cover />}
                <CalenderAppointmentDetail
                    fetchCalenderBookings={fetchCalenderBookings}
                    appointment_id={openAppointmentDetail}
                    onRescheduleSuccess={reloadCalendar}
                    onClose={() => { setOpenAppointmentDetail(null); setClientFormDrawerOpen(false); setNotesDrawerOpen(false); setNotesData(null); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setActiveSidePanel(null); setBookingDetailId(null); setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }}
                    onClientFormOpen={() => { clientFormRef.current?.fetchAndOpen(); setNotesDrawerOpen(false); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setActiveSidePanel(null); setBookingDetailId(null); setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }}
                    clientFormActive={clientFormDrawerOpen}
                    onAppointmentLoaded={(data) => setLoadedAppointmentData(data)}
                    onNotesOpen={(apptData) => { setNotesData(apptData); setNotesDrawerOpen(true); setClientFormDrawerOpen(false); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setActiveSidePanel(null); setBookingDetailId(null); setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }}
                    notesActive={notesDrawerOpen}
                    onOpenPanel={(type, config) => { setActiveSidePanel({type, config}); setNotesDrawerOpen(false); setClientFormDrawerOpen(false); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setBookingDetailId(null); setInvoicePanelBookingId(null); setInvoiceReturnTo(null); }}
                    activeSidePanel={activeSidePanel}
                    onInvoiceClick={(id) => { if (!id) return; setInvoiceReturnTo(null); setBookingDetailId(null); setNotesDrawerOpen(false); setClientFormDrawerOpen(false); setActiveSidePanel(null); setInvoicePanelBookingId(id); }}
                />
            </Box>
        </Dialog>

        {/* ── Modal 3: Form iframe — right-side, 600px, back = reopen 1+2 ── */}
        <Dialog
            open={formIframeUrl !== null}
            onClose={() => setFormIframeUrl(null)}
            maxWidth={false}
            sx={{
                '& .MuiDialog-container': {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    padding: '12px 12px 12px 0',
                },
            }}
            PaperProps={{
                sx: {
                    width: {xs: '100vw', sm: '600px'},
                    height: 'calc(100vh - 24px)',
                    maxHeight: 'calc(100vh - 24px)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    m: 0,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    display: 'flex',
                    flexDirection: 'column',
                }
            }}
        >
            <Box sx={{
                display: 'flex', alignItems: 'center', px: 2, py: 1.5,
                borderBottom: '1px solid #eef0f4', flexShrink: 0, background: '#fff', gap: 1,
            }}>
                <IconButton
                    size="small"
                    onClick={() => setFormIframeUrl(null)}
                    sx={{color: '#A72C68', '&:hover': {background: '#FAEFF5'}}}
                >
                    <ArrowBackIcon sx={{fontSize: 18}} />
                </IconButton>
                <Typography sx={{flex: 1, fontWeight: 700, fontSize: '14px', fontFamily: 'helvetica-lt-std-bold, sans-serif', color: '#1a1a2e'}}>
                    Client Form
                </Typography>
                <IconButton
                    size="small"
                    onClick={() => { setFormIframeUrl(null); setOpenAppointmentDetail(null); setClientFormDrawerOpen(false); }}
                    sx={{color: '#9A9797', '&:hover': {color: '#EB5757', background: '#ffeaea'}}}
                >
                    <CloseIcon sx={{fontSize: 18}} />
                </IconButton>
            </Box>
            {formIframeUrl && (
                <iframe
                    src={formIframeUrl}
                    title="client-form"
                    style={{flex: 1, border: 'none', width: '100%', height: '100%'}}
                />
            )}
        </Dialog>

        {/* ── Add Note Dialog — opens alone, ← restores Patient Records + Appointment Detail ── */}
        <Dialog
            open={addNoteDrawerOpen}
            onClose={() => { setAddNoteDrawerOpen(false); setNotesDrawerOpen(true); }}
            maxWidth={false}
            sx={{
                '& .MuiDialog-container': {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    padding: '12px 12px 12px 0',
                },
            }}
            PaperProps={{
                sx: {
                    width: {xs: '100vw', sm: '500px'},
                    height: 'calc(100vh - 24px)',
                    maxHeight: 'calc(100vh - 24px)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    m: 0,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    display: 'flex',
                    flexDirection: 'column',
                }
            }}
        >
            {notesData && (
                <AddNotesModal
                    appointmentDetails={notesData}
                    panelMode
                    onPanelClose={() => { setAddNoteDrawerOpen(false); setNotesDrawerOpen(true); }}
                    onCloseAll={() => { setOpenAppointmentDetail(null); setNotesDrawerOpen(false); setNotesData(null); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setClientFormDrawerOpen(false); }}
                />
            )}
        </Dialog>

        {/* ── Add Photo Dialog — opens alone, ← restores Patient Records + Appointment Detail ── */}
        <Dialog
            open={addPhotoDrawerOpen}
            onClose={() => { setAddPhotoDrawerOpen(false); setNotesDrawerOpen(true); }}
            maxWidth={false}
            sx={{
                '& .MuiDialog-container': {
                    justifyContent: 'flex-end',
                    alignItems: 'flex-start',
                    padding: '12px 12px 12px 0',
                },
            }}
            PaperProps={{
                sx: {
                    width: {xs: '100vw', sm: '500px'},
                    height: 'calc(100vh - 24px)',
                    maxHeight: 'calc(100vh - 24px)',
                    borderRadius: '16px',
                    overflow: 'hidden',
                    m: 0,
                    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    display: 'flex',
                    flexDirection: 'column',
                }
            }}
        >
            {notesData && (
                <AddAttachmentModal
                    appointmentDetails={notesData}
                    panelMode
                    onPanelClose={() => { setAddPhotoDrawerOpen(false); setNotesDrawerOpen(true); }}
                    onCloseAll={() => { setOpenAppointmentDetail(null); setNotesDrawerOpen(false); setNotesData(null); setAddNoteDrawerOpen(false); setAddPhotoDrawerOpen(false); setClientFormDrawerOpen(false); }}
                />
            )}
        </Dialog>

      </CrmLayout>
  );
}
 
export default CRMCalender;